import React, { useState, useEffect, useContext } from 'react'
import AdminContext from '../../StateContext/Application'
import { apiurl } from '../../../../path'
import { useLanguage } from '../../../../lang/langcontext/LanguageContext'
const BudgetHeadList = () => {
    const { language, toggleLanguage, t } = useLanguage();
    const context = useContext(AdminContext)
    const { GetAllBudgetHeadList } = context
    const [head, setHeadList] = useState([])
    const [filteredBills, setFilteredBills] = useState([]);
    const [currentPage, setCurrentPage] = useState(1);
    const billsPerPage = 10;
    const [searchTerm, setSearchTerm] = useState('');

    const totalPages = Math.ceil(filteredBills?.length / billsPerPage);
    const indexOfLastBill = currentPage * billsPerPage;
    const indexOfFirstBill = indexOfLastBill - billsPerPage;
    const currentBills = filteredBills?.slice(indexOfFirstBill, indexOfLastBill);

    const getBudgetHeadList = async () => {
        let data = await GetAllBudgetHeadList()
        console.log("data", data);

        setHeadList(data)
        setFilteredBills(data);
    }
    useEffect(() => {
        getBudgetHeadList()
    }, [])
    let HeadList = []
    if (head.length > 0) {
        HeadList = head
    }
    useEffect(() => {
        const lowerSearchTerm = searchTerm.toLowerCase();
        const filtered = head.filter(bill =>
            Object.values(bill).some((val) =>
                (val || '').toString().toLowerCase().includes(lowerSearchTerm)
            )
        );
        setFilteredBills(filtered);
        setCurrentPage(1); // Reset to page 1 on search
    }, [searchTerm, head]);


    // return (

    //     <>

    //         <div className="col-12" style={{ backgroundColor: "#EFF3F8", height: "89vh", overflowX: "hidden", overflowY: "scroll" }}>
    //             <div className="col-11 m-auto">

    //                 <div className='col-12 px-4 mb-4 mt-3' style={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
    //                     <h5 className='my-auto fw-bold'>
    //                         <img src="/GR-Approval64.png" alt="Technical Approval" style={{ width: "24px", height: "24px" }} className='my-auto me-1' />
    //                         <span className='my-auto'>Budget Head Report</span>
    //                     </h5>
    //                     {/* <input type="text" placeholder="Search" onChange={(e) => setSearchTerm(e.target.value)} value={searchTerm} style={{ width: "250px", padding: "8px 12px", border: "1px solid #ccc", borderRadius: "5px", backgroundColor: 'aliceblue', fontSize: "14px", marginRight: "10px" }} /> */}
    //                     <div style={{ position: "relative", width: "250px", marginRight: "10px" }}>
    //                         <img
    //                             src="/Search32.png"
    //                             alt="Search Icon"
    //                             style={{
    //                                 position: "absolute",
    //                                 top: "50%",
    //                                 left: "10px",
    //                                 transform: "translateY(-50%)",
    //                                 width: "16px",
    //                                 height: "16px",
    //                                 opacity: 0.6
    //                             }}
    //                         />
    //                         <input
    //                             type="text"
    //                             placeholder="Search Here"
    //                             onChange={(e) => setSearchTerm(e.target.value)}
    //                             value={searchTerm}
    //                             style={{
    //                                 width: "100%",
    //                                 padding: "8px 12px 8px 32px", // left padding makes space for icon
    //                                 border: "1px solid #ccc",
    //                                 borderRadius: "8px",
    //                                 backgroundColor: "#f1f6fc",
    //                                 fontSize: "14px",
    //                                 color: "#333",
    //                                 boxShadow: "0 1px 2px rgba(0,0,0,0.1)",
    //                                 outline: "none"
    //                             }}
    //                         />
    //                     </div>
    //                 </div>
    //                 <div style={{ display: "grid", justifyContent: "center", width: "80vw", maxWidth: "100%", }}>
    //                     <div style={{ background: 'linear-gradient(to Right, #3b409e , #0067ab , #0f79ba , #0098d5 )', display: 'flex', width: '75vw', overflowX: "auto", border: '1px solid #3b409e' }}>
    //                         <table style={{ width: '100%', width: "100%", borderCollapse: "collapse", minWidth: "1200px", }}>
    //                             <thead style={{ borderTop: 'none' }}>
    //                                 <tr style={{ color: 'white', border: 'none', overflow: 'hidden', height: '3.5rem' }}>
    //                                     <th style={{ padding: '8px' }}>Head ID</th>
    //                                     <th style={{ padding: '8px' }}>Head Name</th>
    //                                     <th style={{ padding: '8px' }}>Head Type</th>
    //                                     <th style={{ padding: '8px' }}>Head Details</th>
    //                                     <th style={{ padding: '8px' }}>Head Sanction Amount</th>
    //                                     <th style={{ padding: '8px' }}>CRC</th>
    //                                     <th style={{ padding: '8px' }}>Project Name</th>
    //                                     <th style={{ padding: '8px' }}>Project Cost</th>
    //                                     <th style={{ padding: '8px' }}>Creation Date</th>
    //                                 </tr>
    //                             </thead>
    //                             {
    //                                 currentBills?.map((head, index) => {
    //                                     const bgColor = index % 2 === 0 ? "#E5F4FB" : "#CFE4F1";
    //                                     return (
    //                                         <tbody>
    //                                             <tr style={{ borderBottom: '1px solid #3b409e', backgroundColor: bgColor, }}>
    //                                                 <td style={{ padding: '8px' }}>{head.HeadID}</td>
    //                                                 <td style={{ padding: '8px' }}>{head.HeadName}</td>
    //                                                 <td style={{ padding: '8px' }}>{head.HeadType}</td>
    //                                                 <td style={{ padding: '8px' }}>{head.HeadDetails}</td>
    //                                                 <td style={{ padding: '8px' }}>{head.HeadSanctionAmount}</td>
    //                                                 <td style={{ padding: '8px' }}>{head.CRC}</td>
    //                                                 <td style={{ padding: '8px' }}>{head.ProjectName}</td>
    //                                                 <td style={{ padding: '8px' }}>{head.ProjectCost}</td>
    //                                                 <td style={{ padding: '8px' }}>{head.Date?.split('T')[0].replace(' ')}</td>
    //                                             </tr>
    //                                         </tbody>
    //                                     )
    //                                 })
    //                             }
    //                         </table>
    //                     </div>
    //                 </div>
    //                 <div style={{ display: 'flex', justifyContent: 'space-between', padding: ' 0px 10px 0px 10px', height: '3rem', alignItems: 'center' }}>
    //                     <div>
    //                         <p style={{ margin: '0px', color: 'black' }}>Showing {filteredBills?.length} of {head?.length} entries</p>
    //                     </div>
    //                     <div style={{ display: 'flex', alignItems: 'center' }}>
    //                         {/* First Page Button */}
    //                         <button onClick={() => setCurrentPage(1)} disabled={currentPage === 1}
    //                             style={{ backgroundColor: 'white', color: 'black', border: '1px solid lightgrey', cursor: 'pointer', fontSize: '24px', margin: 0, borderRadius: 0 }}>
    //                             &laquo;
    //                         </button>
    //                         {/* Previous Button */}
    //                         <button
    //                             onClick={() => setCurrentPage(currentPage - 1)}
    //                             disabled={currentPage === 1}
    //                             style={{ backgroundColor: 'white', color: 'black', border: '1px solid lightgrey', cursor: 'pointer', fontSize: '24px', margin: 0, borderRadius: 0, borderLeft: "none" }}>
    //                             &lt;
    //                         </button>

    //                         <button
    //                             style={{ background: 'linear-gradient(to Right, #3b409e , #0067ab , #0f79ba , #0098d5 )', color: 'white', cursor: 'pointer', fontSize: '24px', width: '3rem', margin: 0, borderRadius: 0, border: '1px solid lightgrey', borderLeft: "none" }}>{currentPage}
    //                         </button>
    //                         {/* Next Button */}
    //                         <button
    //                             onClick={() => setCurrentPage(currentPage + 1)}
    //                             disabled={currentPage === totalPages}
    //                             style={{ backgroundColor: 'white', color: 'black', border: '1px solid lightgrey', cursor: 'pointer', fontSize: '24px', margin: 0, borderRadius: 0, borderLeft: "none" }}>
    //                             &gt;
    //                         </button>
    //                         {/* Last Page Button */}
    //                         <button
    //                             onClick={() => setCurrentPage(totalPages)}
    //                             disabled={currentPage === totalPages}
    //                             style={{ backgroundColor: 'white', color: 'black', border: '1px solid lightgrey', cursor: 'pointer', fontSize: '24px', margin: 0, borderRadius: 0, borderLeft: "none" }}>
    //                             &raquo;
    //                         </button>
    //                     </div>

    //                 </div>
    //             </div>
    //         </div>

    //     </>
    // )
        return (

        <>

            <div className="col-12" style={{ backgroundColor: "#EFF3F8", height: "89vh", overflowX: "hidden", overflowY: "scroll" }}>
                <div className="col-11 m-auto">

                    <div className='col-12 px-4 mb-4 mt-3' style={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
                        <h5 className='my-auto fw-bold'>
                            <img src="/GR-Approval64.png" alt="Technical Approval" style={{ width: "24px", height: "24px" }} className='my-auto me-1' />
                            <span className='my-auto'>{t("Budget Head Report")}</span>
                        </h5>
                        {/* <input type="text" placeholder="Search" onChange={(e) => setSearchTerm(e.target.value)} value={searchTerm} style={{ width: "250px", padding: "8px 12px", border: "1px solid #ccc", borderRadius: "5px", backgroundColor: 'aliceblue', fontSize: "14px", marginRight: "10px" }} /> */}
                        <div style={{ position: "relative", width: "250px", marginRight: "10px" }}>
                            <img
                                src="/Search32.png"
                                alt="Search Icon"
                                style={{
                                    position: "absolute",
                                    top: "50%",
                                    left: "10px",
                                    transform: "translateY(-50%)",
                                    width: "16px",
                                    height: "16px",
                                    opacity: 0.6
                                }}
                            />
                            <input
                                type="text"
                                placeholder={t("Search Here")}
                                onChange={(e) => setSearchTerm(e.target.value)}
                                value={searchTerm}
                                style={{
                                    width: "100%",
                                    padding: "8px 12px 8px 32px", // left padding makes space for icon
                                    border: "1px solid #ccc",
                                    borderRadius: "8px",
                                    backgroundColor: "#f1f6fc",
                                    fontSize: "14px",
                                    color: "#333",
                                    boxShadow: "0 1px 2px rgba(0,0,0,0.1)",
                                    outline: "none"
                                }}
                            />
                        </div>
                    </div>
                    <div style={{ display: "grid", justifyContent: "center", width: "80vw", maxWidth: "100%", }}>
                        <div style={{ background: 'linear-gradient(to Right, #3b409e , #0067ab , #0f79ba , #0098d5 )', display: 'flex', width: '75vw', overflowX: "auto", border: '1px solid #3b409e' }}>
                            <table style={{ width: '100%', width: "100%", borderCollapse: "collapse", minWidth: "1200px", }}>
                                <thead style={{ borderTop: 'none' }}>
                                    <tr style={{ color: 'white', border: 'none', overflow: 'hidden', height: '3.5rem' }}>
                                        <th style={{ padding: '8px' }}>{t("Head ID")}</th>
                                        <th style={{ padding: '8px' }}>{t("Head Name")}</th>
                                        <th style={{ padding: '8px' }}>{t("Head Type")}</th>
                                        <th style={{ padding: '8px' }}>{t("Head Details")}</th>
                                        <th style={{ padding: '8px' }}>{t("Head Sanction Amount")}</th>
                                        <th style={{ padding: '8px' }}>{t("CRC")}</th>
                                        <th style={{ padding: '8px' }}>{t("Project Name")}</th>
                                        <th style={{ padding: '8px' }}>{t("Project Cost")}</th>
                                        <th style={{ padding: '8px' }}>{t("Creation Date")}</th>
                                    </tr>
                                </thead>
                                {
                                    currentBills?.map((head, index) => {
                                        const bgColor = index % 2 === 0 ? "#E5F4FB" : "#CFE4F1";
                                        return (
                                            <tbody>
                                                <tr style={{ borderBottom: '1px solid #3b409e', backgroundColor: bgColor, }}>
                                                    <td style={{ padding: '8px' }}>{head.HeadID}</td>
                                                    <td style={{ padding: '8px' }}>{head.HeadName}</td>
                                                    <td style={{ padding: '8px' }}>{head.HeadType}</td>
                                                    <td style={{ padding: '8px' }}>{head.HeadDetails}</td>
                                                    <td style={{ padding: '8px' }}>{head.HeadSanctionAmount}</td>
                                                    <td style={{ padding: '8px' }}>{head.CRC}</td>
                                                    <td style={{ padding: '8px' }}>{head.ProjectName}</td>
                                                    <td style={{ padding: '8px' }}>{head.ProjectCost}</td>
                                                    <td style={{ padding: '8px' }}>{head.Date?.split('T')[0].replace(' ')}</td>
                                                </tr>
                                            </tbody>
                                        )
                                    })
                                }
                            </table>
                        </div>
                    </div>
                    <div style={{ display: 'flex', justifyContent: 'space-between', padding: ' 0px 10px 0px 10px', height: '3rem', alignItems: 'center' }}>
                        <div>
                            <p style={{ margin: '0px', color: 'black' }}>{t("Showing")} {filteredBills?.length} {t("of")} {head?.length} {t("entries")}</p>
                        </div>
                        <div style={{ display: 'flex', alignItems: 'center' }}>
                            {/* First Page Button */}
                            <button onClick={() => setCurrentPage(1)} disabled={currentPage === 1}
                                style={{ backgroundColor: 'white', color: 'black', border: '1px solid lightgrey', cursor: 'pointer', fontSize: '24px', margin: 0, borderRadius: 0 }}>
                                &laquo;
                            </button>
                            {/* Previous Button */}
                            <button
                                onClick={() => setCurrentPage(currentPage - 1)}
                                disabled={currentPage === 1}
                                style={{ backgroundColor: 'white', color: 'black', border: '1px solid lightgrey', cursor: 'pointer', fontSize: '24px', margin: 0, borderRadius: 0, borderLeft: "none" }}>
                                &lt;
                            </button>

                            <button
                                style={{ background: 'linear-gradient(to Right, #3b409e , #0067ab , #0f79ba , #0098d5 )', color: 'white', cursor: 'pointer', fontSize: '24px', width: '3rem', margin: 0, borderRadius: 0, border: '1px solid lightgrey', borderLeft: "none" }}>{currentPage}
                            </button>
                            {/* Next Button */}
                            <button
                                onClick={() => setCurrentPage(currentPage + 1)}
                                disabled={currentPage === totalPages}
                                style={{ backgroundColor: 'white', color: 'black', border: '1px solid lightgrey', cursor: 'pointer', fontSize: '24px', margin: 0, borderRadius: 0, borderLeft: "none" }}>
                                &gt;
                            </button>
                            {/* Last Page Button */}
                            <button
                                onClick={() => setCurrentPage(totalPages)}
                                disabled={currentPage === totalPages}
                                style={{ backgroundColor: 'white', color: 'black', border: '1px solid lightgrey', cursor: 'pointer', fontSize: '24px', margin: 0, borderRadius: 0, borderLeft: "none" }}>
                                &raquo;
                            </button>
                        </div>

                    </div>
                </div>
            </div>

        </>
    )
}

export default BudgetHeadList
